import React, { Fragment, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import KjosandiInfo from "./KjosandiInfo";
import { AppContext } from "store/AppContext";


const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(4, 2),
    marginBottom: theme.spacing(2)
  }
}));

export default function FormStep(props) {
  const classes = useStyles();
  const context = useContext(AppContext);
  const { formState, setFormState, kjosandiInfo, handleNext, handleBack } = props;
  const { kjosandi, fjoldiAtkvaeda } = kjosandiInfo;

  useEffect(() => {
    setFormState(state => ({
      ...state,
      kennitala: kjosandi.kennitala,
      nafn: kjosandi.nafn,
      heimili: kjosandi.husheiti,
      sveitarfelagsnumer: kjosandi.sveitarfelagsnumer,
      numerKjordaemis: kjosandi.numerKjordaemis,
      kjorstadurNumer: kjosandi.kjorstadurNumer,
      kjordeild: kjosandi.kjordeild,
      notandi: context.user.get.details.saml_username,
      notandiKt: context.user.get.details.saml_userssn,
      notandiEmbaettisnumer: parseInt(context.user.get.details.embaettisnumer),
    }));
  }, [setFormState, kjosandi, context]);

  const handleChangeAthugasemd = e => {
    e.persist(); // Used to avoid synthetic event error
    setFormState(formState => ({ ...formState, athugasemd: e.target.value }));
  }

  return (
    <Fragment>
      <KjosandiInfo kjosandi={kjosandi} fjoldiAtkvaeda={fjoldiAtkvaeda} />

      <Paper className={classes.paper}>
        <Grid item xs={12}>
          <TextField
            id="atkvedi-athugasemd"
            label="Athugasemd"
            placeholder="Skrá athugasemd"
            multiline
            rows="2"
            fullWidth
            variant="outlined"
            value={formState.athugasemd}
            onChange={handleChangeAthugasemd}
          />
        </Grid>
      </Paper>

      <Grid
        container
        spacing={2}
        direction="row"
        alignItems="center"
        justify="center"
      >
        <Grid item>
          <Button onClick={handleBack}>Til baka</Button>
        </Grid>
        <Grid item>
          <Button color="primary" variant="contained" onClick={handleNext}>
            Áfram
          </Button>
        </Grid>
      </Grid>
    </Fragment>
  );
}
